import envConfig from '../config.json'

export const env = (window as any).__ASCA_CONFIG__ || envConfig as any;
